<script>
import formdate from "@/router/views/FormComponet/formdate.vue"; 
import formtextarea from "@/router/views/FormComponet/formtextarea.vue"; 
import formcombobox from "@/router/views/FormComponet/formcombobox.vue"; 
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter2.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIyilestirme from "@/models/StrIyilestirme";
import moment from "moment";
export default {
  mixins: [Api, Sabit, StrIyilestirme],
  props: ["Id", "AddEdit" ],
  data() {
    return {
      FormData: {},
      Page: {
        PageNumber: "1",
        PageSize: "1",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader, 
    formtextarea, 
    formdate,BirimSecimi,formcombobox
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.amac_yukle()
    },
  },
  methods: {
    async onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) { 
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          var Filter = "&DESC=Kod&Turid=" + this.FormData.Turid + "&Donemid="+ this.FormData.Donemid
          var response = await this.ActionsFilterGet({ Service: "StrIyilestirme", Page: this.Page, Filter: Filter }) 
            if( response.TotalCount > 0){ 
              this.FormData.Kod = response.Data[0].Kod + 1;
            }
            else{
              this.FormData.Kod = 1;
            } 
          var res = await this.Post("StrIyilestirme", this.FormData) 
            if (res) {
                this.FormData = this.StrIyilestirmeData
                this.$emit("TableUpdate");
                this.$bvModal.hide("StrIyilestirme");
            }
          
        } else {
          this.Update("StrIyilestirme", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIyilestirmeData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIyilestirme");
            }
          });
        }
      }
    }, 
    Get() {},
    
    amac_yukle(){
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      } 
          let Filter = "&DonemId="+this.FormData.Amacdonemid;
          this.FormDataType.Amacid.ComboDataArray=[];

          this.ActionsFilterGet({"Service":"StrStratejikAmac", "Page":Page,Filter:Filter}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {
                  this.FormDataType.Amacid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
                } 
      
          });

    }
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrIyilestirme"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? 'Kaydı Düzenle'
          : 'Kayıt Ekle'
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">  
        <div class="row"> 
           
          <formcombobox class="col-md-6" 
                  :FormDataType="FormDataType.Turid"
                  :Value="FormData.Turid"
                  :v="$v.FormData.Turid"
                  @input="FormData.Turid = $event"
                />
 
          <formcombobox class="col-md-6" 
                  :FormDataType="FormDataType.Donemid"
                  :Value="FormData.Donemid"
                  :v="$v.FormData.Donemid"
                  @input="FormData.Donemid = $event"
                />
 
              <formcombobox class="col-md-6"  v-if="0"
                  :FormDataType="FormDataType.Amacdonemid"
                  :Value="FormData.Amacdonemid"
                  :v="$v.FormData.Amacdonemid"
                  @input="FormData.Amacdonemid = $event,amac_yukle($event)"
                />

                
               <formcombobox class="col-md-6"   v-if="0"
                  :FormDataType="FormDataType.Amacid"
                  :Value="FormData.Amacid"
                  :v="$v.FormData.Amacid"
                  @input="FormData.Amacid = $event"
                />

        <BirimSecimi class="mb-3 col-md-6"
                  :title="FormDataType.Birimids.FieldTitle"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="FormData.Birimids"
                    :labels_lg="'3'"  
                    :v="$v.FormData.Birimids"
                    :multiple="true"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.Birimids=$event"
                  />  


                  
        <formtextarea class="col-md-6"
          :FormDataType="FormDataType.Gelistirme"
          :Value="FormData.Gelistirme"
          :v="$v.FormData.Gelistirme"
          @input="FormData.Gelistirme = $event"
        />
        <formtextarea class="col-md-6"  v-if="0"
          :FormDataType="FormDataType.Iyilestirme"
          :Value="FormData.Iyilestirme"
          :v="$v.FormData.Iyilestirme"
          @input="FormData.Iyilestirme = $event"
        />
        
        <formdate class="col-md-6"
          :FormDataType="FormDataType.Iyilestirmetarih"
          :Value="FormData.Iyilestirmetarih"
          :v="$v.FormData.Iyilestirmetarih"
          @input="FormData.Iyilestirmetarih = $event"
        />
        <formdate class="col-md-6"  v-if="0"
          :FormDataType="FormDataType.Bitistarihi"
          :Value="FormData.Bitistarihi"
          :v="$v.FormData.Bitistarihi"
          @input="FormData.Bitistarihi = $event"
        />
        <formtextarea class="col-md-12"
          :FormDataType="FormDataType.Kanit"
          :Value="FormData.Kanit"
          :v="$v.FormData.Kanit"
          @input="FormData.Kanit = $event"
        />
 
      </div>
        <button class="btn btn-primary" type="submit">
         Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
